import { handleResponse } from "utils/axios";
import { axiosInstance } from "./index";
import { onGetAllRoles, onGetAllSystemAdmin } from "mocksdata/admin-management";

/*Change Get Api here*/
const getApiAdminManagement = async (query) => {
  onGetAllSystemAdmin(query);
  return axiosInstance({
    method: "get",
    url: "/roles/users",
    params: query,
  }).then((res) => {
    const { page, limit, search = "", roles = "" } = query;
    const data =
      res.data?.data?.filter(
        (admin) =>
          admin.email.toLowerCase().indexOf(search.trim().toLowerCase()) !== -1 &&
          (roles ? admin.role === roles : true),
      ) ?? [];
    console.log(data);
    return Promise.resolve({
      ...res,
      data: data.slice((page - 1) * limit, page * limit),
      total: data.length ?? 0,
    });
  });
};

const getAllRoles = async () => {
  onGetAllRoles();
  return axiosInstance({
    method: "get",
    url: "/roles",
  }).then(handleResponse);
};

/*Change Post Api here*/
const createAdmin = async (data) => {
  return await axiosInstance.post("/roles/users/add", data).then(handleResponse);
};

/*Change Put Api here*/
const updateAdminRoles = async (data) => {
  return await axiosInstance.put("/roles/users/update-role", data).then(handleResponse);
};

/*Change Get Api here*/
const deleteAdmin = async (email) => {
  return await axiosInstance
    .delete(`/roles/users/delete?email=${encodeURIComponent(email)}`)
    .then(handleResponse);
};

export { getApiAdminManagement, createAdmin, updateAdminRoles, deleteAdmin, getAllRoles };
